import type { DataTableColumnDef } from 'components/data-table';
import type { TractNRI } from 'components/nri-table';
import { UnvaluedReasonCell } from 'components/unvalued-reason';
import { EMPTY } from './utils';

/**
 * The Unvalued Reason column, shared by the Slot and Slot Allocation grids (INS-12687): the
 * shared UnvaluedReasonCell, which links each fixable reason. Sortable, but a server no-op until
 * the BE projects `unvaluedReason`.
 *
 * @param {number | null} packageId - The package whose edit page an exclusion links to;
 *   null → an exclusion renders unlinked.
 * @return {object} The DataTable column definition.
 */
export function unvaluedReasonColumn<
  T extends TractNRI & Record<string, unknown>,
>(packageId: number | null): DataTableColumnDef<T> {
  return {
    accessorKey: 'unvaluedReason',
    header: 'Unvalued Reason',
    size: 200,
    meta: { type: 'text' },
    cell: (info) => (
      <UnvaluedReasonCell
        reason={info.getValue<string | null | undefined>()}
        row={info.row.original}
        packageId={packageId}
        fallback={EMPTY}
      />
    ),
  };
}
